export default {
    USER_ID: 'user_mEEQCxOcOcR57OPL0b5bm',
    SERVICE_ID: 'service_tyw9yzq',
    IDTEMPLATE_ID: `template_h7gpkem`,
}